import { tableListTypes } from "core/modules/table/constants";

const mockData = () => {
	const tabs = {
		[tableListTypes.TRANSACTION_HISTORY_LIST]: [
			{
				id: "1",
				stage: "Transactions",
				tabName: null,
				query: null,
				role: "R0",
				database: null,
				order: 0,
				defaultSelected: true,
				applicationCount: 187,
				filters: [
					{
						id: "storeId",
						filterName: "Store name",
						type: "inputGroup",
						variant: "horizontal",
						treatAsOption: false,
						sequence: 0,
						filterOption: [
							{
								id: "111",
								name: "Select store name",
								value: "",
								options: [],
								filterAvailable: false,
								optionType: null,
								sequence: 1,
								filters: [],
								selected: false,
							},
						],
						selectedValueIndexes: [],
					},
					{
						id: "status",
						filterName: "Loan status",
						type: "radioLabel",
						variant: "vertical",
						treatAsOption: false,
						sequence: 0,
						filterOption: [
							{
								id: "121",
								name: "Approved",
								value: "APPROVED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 0,
								filters: [],
								selected: false,
							},
							{
								id: "122",
								name: "Rejected",
								value: "REJECTED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 9,
								filters: [],
								selected: false,
							},
							{
								id: "123",
								name: "TBD",
								value: "TBD",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 10,
								filters: [],
								selected: false,
							},
							{
								id: "124",
								name: "Withdrawn",
								value: "WITHDRAWN",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 11,
								filters: [],
								selected: false,
							},
							{
								id: "125",
								name: "Disbursed",
								value: "DISBURSED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 12,
								filters: [],
								selected: false,
							},
							{
								id: "126",
								name: "Approval Pending",
								value: "DEALER_APPROVAL_PENDING",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
							{
								id: "127",
								name: "Refunded",
								value: "REFUNDED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
							{
								id: "140",
								name: "Created",
								value: "CREATED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
							{
								id: "141",
								name: "Bs Required",
								value: "BS_REQUIRED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
						],
						selectedValueIndexes: [],
					},
					{
						id: "subStatus",
						filterName: "Loan sub status",
						type: "radioLabel",
						variant: "vertical",
						treatAsOption: false,
						sequence: 0,
						filterOption: [
							{
								id: "128",
								name: "KYC Pending",
								value: "KYC_PENDING",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 0,
								filters: [],
								selected: false,
							},
							{
								id: "130",
								name: "IMPS Pending",
								value: "IMPS_PENDING",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 10,
								filters: [],
								selected: false,
							},
							{
								id: "129",
								name: "Selfie Pending",
								value: "Selfie_Pending",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 10,
								filters: [],
								selected: false,
							},
							{
								id: "142",
								name: "NACH Pending",
								value: "NACH_PENDING",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 11,
								filters: [],
								selected: false,
							},
							{
								id: "132",
								name: "LA Pending",
								value: "LA_PENDING",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 12,
								filters: [],
								selected: false,
							},
							{
								id: "133",
								name: "Down Payment Pending",
								value: "DOWN_PAYMENT_PENDING",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
							{
								id: "134",
								name: "KFS Pending",
								value: "KFS_PENDING",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
							{
								id: "136",
								name: "User Cancelled",
								value: "USER_CANCELLED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
							{
								id: "137",
								name: "Dealer Reject",
								value: "DEALER_REJECT",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
							{
								id: "138",
								name: "Expired",
								value: "EXPIRED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
							{
								id: "139",
								name: "Soft Rejected",
								value: "SOFT_REJECTED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
							{
								id: "144",
								name: "Hard Rejected",
								value: "HARD_REJECTED",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 13,
								filters: [],
								selected: false,
							},
						],
						selectedValueIndexes: [],
					},
					{
						id: "dateRange",
						filterName: "Transaction date",
						type: "date_range",
						variant: "horizontal",
						treatAsOption: false,
						sequence: 0,
						filterOption: [
							{
								id: "135",
								placeholder: "Start date - End date",
								dateValue: "",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 0,
								filters: [],
								selected: false,
							},
						],
						selectedValueIndexes: [],
					},
				],
				tableColumnConfig: null,
				actionConfig: null,
			},
		],
		[tableListTypes.PENDING_TRANSACTIONS_LIST]: [
			{
				id: "2",
				stage: "Pending",
				tabName: null,
				query: null,
				role: "R0",
				database: null,
				order: 0,
				defaultSelected: true,
				applicationCount: 100,
				filters: [
					{
						id: "storeId",
						filterName: "Store name",
						type: "inputGroup",
						variant: "horizontal",
						treatAsOption: false,
						sequence: 0,
						filterOption: [
							{
								id: "111",
								name: "Select store name",
								value: "",
								options: [],
								filterAvailable: false,
								optionType: null,
								sequence: 1,
								filters: [],
								selected: false,
							},
						],
						selectedValueIndexes: [],
					},
					{
						id: "dateRange",
						filterName: "Transaction date",
						type: "date_range",
						variant: "horizontal",
						treatAsOption: false,
						sequence: 0,
						filterOption: [
							{
								id: "131",
								placeholder: "Start date - End date",
								dateValue: "",
								options: null,
								filterAvailable: false,
								optionType: null,
								sequence: 0,
								filters: [],
								selected: false,
							},
						],
						selectedValueIndexes: [],
					},
				],
				tableColumnConfig: null,
				actionConfig: null,
			},
		],
	};
	return { tabs };
};
export default mockData;
